import '../css/MyPage.css';

export function MyPage() {
    return (
        <div className="myPage"></div>
    );
}
